// hooks/useSetNewPassword.ts
import { useState } from 'react';

export const useSetNewPassword = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const setNewPassword = async ({ token, password }: { token: string, password: string }) => {
        setLoading(true);
        setError('');

        await new Promise(resolve => setTimeout(resolve, 1000));

        if (password === 'fail') {
            setError('Ошибка восстановления');
            setLoading(false);
            return false;
        }

        setLoading(false);
        return true;
    };

    return { setNewPassword, loading, error };
};
